import { Component } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div class="loading-overlay" *ngIf="loading$ | async">
      <div class="loading-card p-card w-25rem">
        <p-progressSpinner [style]="{ width: '100px', height: '100px' }"></p-progressSpinner>
        <p class="loading-message">Cargando...</p>
      </div>
    </div>
  `,
  styles: [
    `
      .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 3000;
      }

      .loading-card {
        background: #ffffff;
        padding: 2rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        text-align: center;
      }

      .loading-message {
        margin-top: 1rem;
        font-size: 1.2rem;
        color: #333333;
      }

      ::ng-deep .p-progress-spinner {
        svg {
          circle {
            stroke: #003652 !important;
            stroke-width: 3;
          }
        }
      }
    `,
  ],
})
export class LoadingComponent {
  loading$ = this.loadingService.loading$;

  constructor(private loadingService: LoadingService) {}
}
